import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-upload-plus',
  templateUrl: './icon-upload-plus.component.svg',
  styleUrls: ['./icon-upload-plus.component.css'],
})
export class IconUploadPlusComponent {}
